export default __webpack_public_path__ + "svg/who/fse+.svg?07acf37c";